import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'EMA',
  version: 2,
  label: 'Exponential Moving Average',
  pane: 'main',
  category: 'trend',
  series: 'price',
  order: 20,
  inputs: [period('timeperiod', 30)],
  outputs: [line('ema', 'EMA', COLOR.orange)],
  talib: { functions: ['EMA'], expr: 'EMA(close, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod - 1,
}
export default def
